const SectionItemTitle = ({ title }) => {
  return <h3 className="text-xs md:text-sm lg:text-md font-section-sub-title">{title}</h3>;
};

export default SectionItemTitle;
